import React, { SFC } from 'react';
import styled from 'styled-components';

import { Button } from 'antd';

interface SubformSaveButtonProps {
    isSaving: boolean;
    onSave: () => void;
}

const SubformSaveButtonWrapper = styled.div`
    display: flex;
    flex-direction: row-reverse;
`;

const stylePrimary = {
    backgroundColor:'#a8123e', borderColor:'#a8123e'
};

export const SubformSaveButton: SFC<SubformSaveButtonProps> = ({ isSaving, onSave }) => (
    <SubformSaveButtonWrapper>
        <Button type="primary" loading={isSaving} onClick={onSave} style={stylePrimary}>
            Guardar
        </Button>
    </SubformSaveButtonWrapper>
);
